import { FunctionComponent } from 'react';

import styles from './Header.module.scss';

interface HeaderProps {
  title?: string;
  logoSrc: string;
}

type FC = FunctionComponent<HeaderProps>;

const Header: FC = ({ title, logoSrc }: HeaderProps) => (
  <div className={styles.header}>
    <p className={styles.headerText}>{title}</p>
    <img alt="logo" className={styles.headerLogo} src={logoSrc} />
  </div>
);

export default Header;
